import React, { useEffect, useState } from "react";
import "./ContactCard.css";
import { Avatar } from "@material-ui/core";
import { useContext } from "react";
import { ChatContext } from "../../../contexts/ChatContext";
import { Badge, Box, Stack, Typography, alpha } from "@mui/material";
import LetterAvatarsecond from "../../AvatarSecond";
import { socket } from "../Socket/Socket";
import { capitalize } from 'lodash';
import ChatServices from "../../../services/ChatServices";
import VideoContext from "../../../contexts/VideoContext";

const GroupCard = ({ contact, index, isHighlighted = false }) => {

  const { setSelectedContactId, setShowFilePage, userId, setSelectedGroupId, setSelectedContactChat, setSelectedInboxId, setColorIndex, DeleteGroupId, setDeleteGroupId } = useContext(ChatContext);

  const [unreadMessagesCount, setUnreadMessagesCount] = useState(contact.unreadCount);
  const [isDarkMode, setIsDarkMode] = useState(false);
  
  useEffect(() => {
    const updateTheme = () => {
      const theme = localStorage.getItem('ThemeSwitch');
      setIsDarkMode(theme === 'true');
    };
    updateTheme();
    window.addEventListener('storage', updateTheme);
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === 'ThemeSwitch') {
        updateTheme();
      }
    };
    return () => {
      window.removeEventListener('storage', updateTheme);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  const openChat = (id) => {
    setSelectedContactId(null);
    setSelectedGroupId(id);
    setSelectedContactChat(contact);
    setSelectedInboxId(contact._id);
    setColorIndex(index);
    setShowFilePage(false);
    socket.emit('join_group_room', { groupId: id });
    fetchunReadMsg(id);
    setDeleteGroupId(contact.groupId);
  };

  const member = contact?.members?.reduce((acc, member, index, array) => {
    const name = member.userName + (index === array.length - 1 ? '' : ', ');
    if (acc.length + name.length <= 50) {
      acc += name;
    }
    return acc;
  }, '').trim();

  const fetchunReadMsg = async (id) => {
    try {
      const response = await ChatServices.markReadgroupMsg(userId, id);
      if (response.status === 200) {
        setUnreadMessagesCount(0);
      } else {
        console.error("Error Opening Chat:", response.message);
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
    }
  };

  // Determine background color based on highlight, unread count, and dark mode
  const getBackgroundColor = () => {
    if (isHighlighted) {
      return alpha("#667eea", 0.15);
    }
    if (isDarkMode) {
      return unreadMessagesCount === 0 ? "#2a2a2a" : "#1e3a5f";
    }
    return unreadMessagesCount === 0 ? '#fff' : '#B4D4FF';
  };

  return (
    <div 
      className="contactcard" 
      style={{ 
        backgroundColor: getBackgroundColor(),
        padding: '8px 12px',
        margin: 0,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        borderLeft: isHighlighted ? '4px solid #667eea' : '4px solid transparent',
        borderRadius: '8px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }} 
      onClick={() => openChat(contact._id)}
    >
      <Box display='flex' flexDirection='row' alignItems='center' gap={2}>
        <LetterAvatarsecond name={contact.name} />
        <div className="contactcard__username">
          <h3 style={{ 
            margin: 0, 
            fontSize: '1rem', 
            fontWeight: isHighlighted ? 600 : 500,
            color: isDarkMode ? '#fff' : '#1a1a1a'
          }}>
            {capitalize(contact.name)}
          </h3>
          <Typography 
            variant='caption' 
            sx={{ 
              color: isDarkMode ? 'rgba(255,255,255,0.6)' : 'text.secondary',
              fontSize: '0.7rem',
              display: 'block'
            }}
          >
            {member}
          </Typography>
        </div>
      </Box>
      <Box display='flex' justifyContent='flex-end' alignItems='center'>
        {unreadMessagesCount > 0 && (
          <Badge 
            color="primary" 
            badgeContent={unreadMessagesCount} 
            max={999}
            sx={{
              '& .MuiBadge-badge': {
                backgroundColor: '#1976d2',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '0.7rem',
                height: '18px',
                minWidth: '18px',
                borderRadius: '9px',
              }
            }}
          />
        )}
      </Box>
    </div>
  );
};

export default GroupCard;